module.exports = __webpack_public_path__ + "img/29.1b48531f.svg";